var map = {
	"./coventry-city-logo-icon.webp": "8c0c",
	"./deportivo-la-coruna-logo-icon.webp": "e13f",
	"./derby-county-logo-icon.webp": "151d",
	"./hull-city-logo-icon.webp": "f5c8",
	"./kruger-united-logo-icon.webp": "feb9",
	"./le-mans-logo-icon.webp": "39f4",
	"./milford-logo-icon.webp": "006a",
	"./racing-de-santander-logo-icon.webp": "33ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59a0";